import { useCurrentUser } from "@/services/hooks";
import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";

import PollCard from "@/components/PollCard";
import PollResultCard from "@/components/PollResultCard";

export default function PollContainer({ content }) {
  const [voted, setVoted] = useState(false);
  const { data: currentUser } = useCurrentUser();

  // if currentUser is artist, set voted to true
  useEffect(() => {
    if (currentUser?.role === "artist") {
      setVoted(true);
    }
  }, [currentUser]);

  return (
    <Box sx={{ my: 2 }}>
      {!voted && <PollCard content={content} setVoted={setVoted} />}
      {voted && <PollResultCard content={content} />}

      {currentUser?.role === "artist" &&
        currentUser?.key === content.owner.key && (
          <>
            {!voted && (
              <Button onClick={() => setVoted(true)}>Show results</Button>
            )}
            {voted && (
              <Button
                color="info"
                onClick={() => setVoted(false)}
                sx={{ mt: 1 }}
              >
                Hide results
              </Button>
            )}
          </>
        )}
    </Box>
  );
}
